module.exports = __webpack_public_path__ + "static/media/KN.18c01026.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/KN.svg
// module id = 290
// module chunks = 0